import * as React from 'react';
import { useState } from 'react';
import cn from 'classnames';
import Collapse from '@mui/material/Collapse';
import { useTranslation } from 'react-i18next';

import { arrowIcon, infoIcon } from '../Icons';
import { useTheme } from '../../../theme';

interface Props {
	warning: string;
	defaultOpen?: boolean;
}

const Warning: React.FC<Props> = ({ warning, defaultOpen = false }) => {
	const { t } = useTranslation('Warnings');
	const { Warning: theme } = useTheme('MealService');
	const [warningIsOpen, setWarningIsOpen] = useState(defaultOpen);

	const toggleWarning = () => setWarningIsOpen(state => !state);

	return (
		<div className={theme.warning}>
			<div className={theme.warning__trigger} onClick={toggleWarning}>
				<span className={theme.warning__title}>
					{infoIcon} {t('Clarification')}
				</span>

				<span
					className={cn(theme.warning__arrow, {
						[theme.warning__arrow_rotated]: warningIsOpen
					})}
				>
					{arrowIcon}
				</span>
			</div>

			<Collapse in={warningIsOpen}>
				<div className={theme.warning__text}>{t(warning)}</div>
			</Collapse>
		</div>
	);
};

export default Warning;
